import { useState } from "react";
import { toast } from "sonner";
import { Send, MessageCircleHeart } from "lucide-react";
import { calFetch } from "@/lib/calApi";

export function WishBox({ wishKey, initial = [], isMine, testId }) {
  const [wishes, setWishes] = useState(initial);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try {
      const r = await calFetch("/cal/wish", { method: "POST", body: { wish_key: wishKey, text: text.trim() } });
      setWishes(r.wishes);
      setText("");
      toast.success("¡Saludo enviado! 💛");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid={testId} className="mt-4 pt-4 border-t border-line/70">
      <p className="flex items-center gap-1.5 text-xs uppercase tracking-[0.15em] text-amber-deep font-semibold mb-3">
        <MessageCircleHeart className="w-3.5 h-3.5" />
        {wishes.length ? `${wishes.length} ${wishes.length === 1 ? "saludo" : "saludos"}` : "Sé el primero en saludar"}
      </p>
      {wishes.length > 0 && (
        <ul className="space-y-2 mb-3 max-h-56 overflow-y-auto no-scrollbar">
          {wishes.map((w, i) => (
            <li key={i} data-testid={`${testId}-item-${i}`} className="rounded-2xl rounded-tl-sm bg-paper border border-line px-3.5 py-2.5">
              <p className="text-[11px] font-semibold text-cocoa">{w.name}</p>
              <p className="font-serif text-cocoa-soft text-[15px] leading-snug">{w.text}</p>
            </li>
          ))}
        </ul>
      )}
      {!isMine && (
        <form onSubmit={send} className="flex gap-2">
          <input data-testid={`${testId}-input`} value={text} onChange={(e) => setText(e.target.value)} maxLength={500}
            placeholder="Escríbele un saludo…"
            className="flex-1 min-w-0 px-4 py-2.5 rounded-full bg-paper border border-line text-sm text-cocoa focus:outline-none focus:ring-2 focus:ring-amber-deep/30" />
          <button data-testid={`${testId}-send`} disabled={busy || !text.trim()} aria-label="Enviar saludo"
            className="shrink-0 w-10 h-10 rounded-full bg-amber-deep text-paper flex items-center justify-center disabled:opacity-40 cal-press">
            <Send className="w-4 h-4" />
          </button>
        </form>
      )}
    </div>
  );
}
